module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-7.ce78b7a5.jpg";